import React, { useEffect, useState } from 'react';
import './task-list-header.css';

// redux
import { useSelector } from 'react-redux';
import { selectOutboundFlights, selectInboundFlights } from '_redux/slices/timeline/flight-information-list';
import { set } from 'date-fns';

const TaskListHeader = (props) => {

  const [flight, setFlight] = useState('');
  const [carrierCode, setCarrierCode] = useState('');
  const [flightNumber, setFlightNumber] = useState('');
  const [departureAirport, setDepartureAirport] = useState('');
  const [arrivalAirport, setArrivalAirport] = useState('');
  const [type, setType] = useState('');
  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState('');
  const [statusText, setStatusText] = useState('');
  const [statusTime, setStatusTime] = useState('');
  const [statusGate, setStatusGate] = useState('');
  const [statusTerminal, setStatusTerminal] = useState('');
  const [aircraftType, setAircraftType] = useState(''); 
  const [aircraftRegistration, setAircraftRegistration] = useState('');
  const [formattedTime, setFormattedTime] = useState('');

  // redux
  const outboundFlights = useSelector(selectOutboundFlights);
  const inboundFlights = useSelector(selectInboundFlights);  

  useEffect(() => {
    if(props.flight){
      setFlight(props.flight);
      // seperate carrier code and flight number
      let carrierCode = props.flight.substring(0, 2);
      let flightNumber = props.flight.substring(2);
      setCarrierCode(carrierCode);
      setFlightNumber(flightNumber);
    }
  }, [props]);
  
  useEffect(() => {
    if(flight && flight.length > 0){

      //console.log('outbound flights', outboundFlights);

      // find flight info in flight information lists
      let flightInfo = outboundFlights.find(f => f.flightNumber === flight);
      if(flightInfo){
        //console.log('flight info', flightInfo);
        if(flightInfo){
          //console.log('flight info', flightInfo);
          setAircraftRegistration(flightInfo.aircraftRegistration);
          setAircraftType(flightInfo.aircraftType);
          setDepartureAirport(flightInfo.departureAirport);
          setArrivalAirport(flightInfo.arrivalAirport);
          setType(flightInfo.type);
          setStatus(flightInfo.operationInfo.status);
          setStatusType(flightInfo.operationInfo.statusType);
          setStatusTime(flightInfo.operationInfo.time);
          setStatusGate(flightInfo.gate);
          setStatusTerminal(flightInfo.terminal);
        }
      }
      else {
        flightInfo = inboundFlights.find(f => f.flightNumber === flight);
        if(flightInfo){
          //console.log('flight info', flightInfo);
          setAircraftRegistration(flightInfo.aircraftRegistration);
          setAircraftType(flightInfo.aircraftType);
          setDepartureAirport(flightInfo.departureAirport);
          setArrivalAirport(flightInfo.arrivalAirport);
          setType(flightInfo.type);
          setStatus(flightInfo.operationInfo.status);
          setStatusType(flightInfo.operationInfo.statusType);
          setStatusTime(flightInfo.operationInfo.statusTime);
          setStatusGate(flightInfo.gate);
          setStatusTerminal(flightInfo.terminal);
        }
        else {
          //console.log('flight not found');
        }
      }
    }
  }, [flight]);

  useEffect(() => {
    if(statusTime && statusTime.length > 0){
      const date = new Date(statusTime);
      const hours = date.getUTCHours().toString().padStart(2, '0');
      const minutes = date.getUTCMinutes().toString().padStart(2, '0');
      const time = `${hours}:${minutes}`;
      console.log('time ', statusTime)
      setFormattedTime(time);
    }
  }, [statusTime]);

  return (
    <div className="task-list-header">
      <div className="flight-code">
        <span className="flight-airline">{carrierCode}</span>
        <span className="flight-number">{flightNumber}</span>
        <span className="flight-destination">{ type == 'departure' ? arrivalAirport : departureAirport}</span>
      </div>
      <div className="schedule-container">
        <div className="flight-schedule">
          <span className="schedule-text">{status}</span>
          <span className="schedule-time">{formattedTime}</span>
        </div>
        <div className="flight-details">
          <span className="detail">
            <i className="fas fa-plane"></i>{aircraftType} - {aircraftRegistration}
          </span>
          <span className="detail">
            <i className="fas fa-clock"></i>{statusType}
          </span>
          <span className="detail">
            <i className="fas fa-door-open"></i>{'Gate: ' + statusGate}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TaskListHeader;
